import email from "../assets/email.png";
import mobile from "../assets/mobile.png";
import api from "../assets/api.png";
import cpp from "../assets/cpp.png";
import css from "../assets/css.png";
import figma from "../assets/figma.png";
import flutter from "../assets/flutter.png";
import git from "../assets/git.png";
import graphql from "../assets/graphql.png";
import html from "../assets/html.png";
import javascript from "../assets/javascript.png";
import mu5 from "../assets/mu5.png";
import node from "../assets/node.png";
import python from "../assets/python.png";
import react from "../assets/react.png";
import redux from "../assets/redux.png";
import sass from "../assets/sass.png";
import typescript from "../assets/typescript.png";
import vue from "../assets/vue.png";

import about01 from "../assets/about01.png";
import about02 from "../assets/about02.png";
import about03 from "../assets/about03.png";
import about04 from "../assets/about04.png";

import profile from "../assets/profile.png";
import circle from "../assets/circle.svg";
import logo from "../assets/logo.png";

import adidas from "../assets/adidas.png";
import amazon from "../assets/amazon.png";
import asus from "../assets/asus.png";
import bolt from "../assets/bolt.png";
import nb from "../assets/nb.png";
import skype from "../assets/skype.png";
import spotify from "../assets/spotify.png";
import profile1 from "../assets/profile1.jpg";
import profile2 from "../assets/profile2.png";
import profile_logo from "../assets/profile_logo.png";
import profile1_logo from "../assets/profile1_logo.png";
import about_section_photo from "../assets/about_section_photo.svg";
import booking_shot from "../assets/booking_shot.jpg";
import shine_shot from "../assets/shine_shot.jpg";
import geekbuying_shot from "../assets/geekbuying_shot.jpg";
import chakra_ui from "../assets/chakra_ui.png";
import nextjs_icon from "../assets/nextjs_icon.png";
import we_fit from "../assets/we_fit.png";
import vs_code from "../assets/vs_code.png";
import vercel from "../assets/vercel.svg";
import netlify from "../assets/netlify.png";
import window_10 from "../assets/windows-10.png";
import npm from "../assets/npm.png";
import express from "../assets/express.png";
import nodejs from "../assets/node-js.png";
import mongodb from "../assets/mongodb.png";
import profileHero from "../assets/profile2.jpg";
import rmbgprofile from "../assets/rm_bg_profile.png";
import violeta from "../assets/violeta_app.png";
const images = {
  violeta,
  rmbgprofile,
  profileHero,
  express,
  nodejs,
  mongodb,
  vs_code,
  netlify,
  window_10,
  npm,
  vercel,
  we_fit,
  nextjs_icon,
  chakra_ui,
  booking_shot,
  shine_shot,
  geekbuying_shot,
  about_section_photo,
  profile_logo,
  profile1_logo,
  profile2,
  profile1,
  email,
  mobile,
  api,
  cpp,
  css,
  figma,
  flutter,
  git,
  graphql,
  html,
  javascript,
  mu5,
  node,
  python,
  react,
  redux,
  sass,
  typescript,
  vue,
  about01,
  about02,
  about03,
  about04,
  profile,
  circle,
  logo,
  adidas,
  amazon,
  asus,
  bolt,
  nb,
  skype,
  spotify,
};
export default images;
